export type CheckboxState = "checked" | "unChecked" | "allChecked";

export enum CHECKBOX_SIZE {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small",
}

export interface CheckboxIconProps {
  selected: CheckboxState;
}

export interface CheckboxProps {
  id: string;
  selected: CheckboxState;
  handleOnChange?: (id: string, checked: boolean) => void;
  label: string;
  size?: CHECKBOX_SIZE;
  disabled?: boolean;
  className?: string;
  checkboxClassName?: string;
}

export interface SizeClassNames {
  inputClassName: string;
  labelClassName: string;
}
